export default function BrandSection() {
  return (
    <div className="tw-bg-white tw-py-11 tw-flex tw-items-center tw-justify-center tw-gap-7">
      <img
        src="/eume/eume-logo.png"
        alt="EUME"
        className="tw-w-[46px] tw-h-12 tw-object-contain"
      />
      <span className="tw-w-px tw-h-9 tw-bg-[#111]" />
      <img
        src="/nestroot/logo-dark.png"
        alt="Protega"
        className="tw-w-[126px] tw-h-[19px] tw-object-contain"
      />
    </div>
  );
}
